const config = {
    reviewer: {
        rightClickAction: 'control', // [control, select]
        leftClickAction: 'control',
        controls: ['play', 'corrections'] // [play, personage, type, corrections, split, merge, delete]
    },
    editor: {
        rightClickAction: 'control',
        leftClickAction: 'select',
        controls: ['play', 'personage', 'type', 'corrections', 'split', 'merge', 'delete']
    },
    default: {
        rightClickAction: 'control', // [control, select]
        leftClickAction: 'select',
        controls: ['play', 'personage', 'type', 'corrections', 'split', 'merge', 'delete']
    }
};

export const actionMethodMap = {
    control: 'openControl',
    select: 'select'
};

export const getConfig = (role = 'default') => config[role] || config.default;
